/**
 * Point d'accès unique à toutes les variables d'environnement.
 *
 * Vite injecte les variables `VITE_*` au build via `import.meta.env`.
 * Les types sont déclarés dans `src/vite-env.d.ts`.
 *
 * NE PAS lire `import.meta.env.*` directement hors de ce fichier.
 * Toujours passer par `env.*`.
 */

export type AppEnv = 'development' | 'staging' | 'production'

const _appEnv = import.meta.env.VITE_APP_ENV ?? 'development'

export const env = {
  /** Nom de l'environnement courant */
  APP_ENV: _appEnv as AppEnv,

  /** URL de base de l'API backend */
  API_URL: import.meta.env.VITE_API_URL ?? 'http://localhost:8000/api/v1',

  /** Nom de l'application (affiché dans l'UI et le titre) */
  APP_NAME: import.meta.env.VITE_APP_NAME ?? 'TicketFlow',

  /** URL publique du backoffice (utilisée pour les liens partageables) */
  PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL ?? 'http://localhost:5173',

  /** Raccourcis booléens */
  IS_DEV:     _appEnv === 'development',
  IS_STAGING: _appEnv === 'staging',
  IS_PROD:    _appEnv === 'production',
} as const
